module.exports = __webpack_public_path__ + "static/sprite3-896ea511bd8fc8c98831257c825e87e8.png";